import type { Messenger } from 'common/messenger'
import type { Nullable } from 'common/types'
import type { FC, ReactElement } from 'react'
import { Route, Routes } from 'react-router-dom'

import { AuthProvider } from './AuthProvider'
import { Logout } from './Logout'

type AuthOuterAppWrapperProps = {
  children?: (getToken: () => Nullable<string> | undefined, logout: () => void) => ReactElement
  coreMessenger?: Messenger
}

const AuthOuterAppWrapper: FC<AuthOuterAppWrapperProps> = ({ children, coreMessenger }) => {
  return (
    <Routes>
      <Route
        path="/*"
        element={<AuthProvider coreMessenger={coreMessenger}>{children}</AuthProvider>}
      />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  )
}

export default AuthOuterAppWrapper
